import React, { Fragment, useEffect, useState, useRef } from "react";
import { Modal, Form, Button, Table } from "react-bootstrap";
import { toast } from 'react-toastify';
import { Icon } from "react-icons-kit";
import { xCircle } from 'react-icons-kit/feather/xCircle';

const EditLayoutModal = ({
	handleLayoutModelOpen,
	handleLayoutModelClose,
	handleLayoutModalSave,
	customerUnitMixData,
	duplicatesUnitData,
	handleDuplicatesData,
	setCustomerUnitMixData,
	handleConfirmMixDeleteSubmit
}) => {

	const [unitMixData, setUnitMixData] = useState()
	const [localCustomerData, setLocalCustomerData] = useState([])
	const inputRefs = useRef([])
	const [showDeleteModal, setShowDeleteModal] = useState(false)
	const [deleteIndex, setDeleteIndex] = useState(null)
	const hasNewUnits = localCustomerData.some(unit => !unit.unitId)

	// function to modify modal listing
	const handleUnitMixData = (value) => {
		let obj = {}
		let arr = []
		value.map(data => {
			obj.unitType = data.unitType
			arr.push({ unitName: data.unitName, unitId: data.unitId, createdByRole: data.createdByRole })
		})
		obj.unitName = arr
		setUnitMixData(obj)
	}

	useEffect(() => {
		let obj = {}
		let arr = []

		localCustomerData.forEach(data => {
			obj.unitType = data.unitType
			arr.push({ unitName: data.unitName, unitId: data.unitId, createdByRole: data.createdByRole })
		})

		obj.unitName = arr
		setUnitMixData(obj)
	}, [localCustomerData])

	useEffect(() => {
		if (customerUnitMixData && customerUnitMixData.length > 0) {
			handleUnitMixData(customerUnitMixData)
			setLocalCustomerData(customerUnitMixData)
		}
	}, [customerUnitMixData])

	useEffect(() => {
		inputRefs.current = inputRefs.current.slice(0, unitMixData?.unitName?.length || 0);
	}, [unitMixData])

	// function to modify unit name
	const handleUnitNameChange = (value, index) => {
		const updated = [...localCustomerData]
		updated[index].unitName = value
		updated[index].unit = value
		setLocalCustomerData(updated)
	};

	// function to modify unit type
	const handleUniTypeChange = (customerData, value) => {
		if (customerData && customerData.length > 0) {
			customerData.map(data => {
				data.unitType = value
			})
		}
		handleUnitMixData(customerData)
	}

	// function to handle unit type change
	const handleUnitMixTypeChange = (e, value) => {
		handleUniTypeChange(customerUnitMixData, e.target.value)
	}

	// function to handle duplicate unit name value 
	const handleDuplicateUnitName = () => {
		let uniqueValues = new Set(customerUnitMixData.map(v => v.unitName.trim()));
		if (uniqueValues.size < customerUnitMixData.length) {
			return true
		} else {
			return false
		}
	}

	// function to handle save unit mix
	const handleAddAndSaveNewUnits = () => {
		if (localCustomerData.some(e => e.unitName.trim() === "") || localCustomerData.some(e => e.unitType === "")) {
			toast.error("Unit name or unit type cannot be left empty")
			return
		}
		const uniqueNames = new Set(localCustomerData.map(e => e.unitName.trim()))
		if (uniqueNames.size < localCustomerData.length) {
			handleDuplicatesData(localCustomerData)
			toast.error("Unit name already exists")
			return
		}
		const newUnits = localCustomerData.filter(unit => !unit.unitId);
		if (newUnits.length === 0) {
			toast.info("No new units to save.")
			return
		}
		const updatedUnits = newUnits.map(e => ({
		  ...e,
		  unitName: e.unitName.trim(),
		  unit: e.unit.trim()
		}));
		handleLayoutModalSave(updatedUnits, 'add')
		setShowDeleteModal(false)
	}

	// function to handle save unit mix
	const handleLayoutUnitMixSave = () => {
		if (customerUnitMixData.some(e => e.unitName.trim() === "") || customerUnitMixData.some(e => e.unitType === "")) {
			toast.error("Unit name or unit type cannot be left empty");
		} else {
			let isChecked = handleDuplicateUnitName()
			if (isChecked) {
				handleDuplicatesData(customerUnitMixData)
				toast.error("Unit name already exists");
			} else {
				const updatedUnits = customerUnitMixData.map(e => ({
				  ...e,
				  unitName: e.unitName.trim(),
				  unit: e.unit.trim()
				}));
				handleLayoutModalSave(updatedUnits, 'edit')
			}
		}
	}

	// function to handle close unit mix
	const handleLayoutUnitMixClose = () => {
		handleLayoutModelClose()
	}

	// Add a new blank unit input
	const handleAddUnit = () => {
		const base = localCustomerData?.[0];
		const newUnit = {
			unitId: "",
			unitName: "",
			unit: "",
			unitType: base?.unitType || "",
			unitTypeId: base?.unitTypeId || null,
			contactInfoId: base?.contactInfoId || null,
			createdBy: base?.createdBy || 1,
		};

		const updated = [...localCustomerData, newUnit];
		setLocalCustomerData(updated);

		setTimeout(() => {
			const lastIndex = updated.length - 1;
			inputRefs.current[lastIndex]?.focus();
		}, 100);
	};

	// funtion to handle delete confirmation
	const handleConfirmDelete = () => {
		if (deleteIndex !== null) {
			if(deleteIndex?.isNewUnit === true){
				const updated = [...localCustomerData]
				updated.splice(deleteIndex.index, 1)
				setLocalCustomerData(updated)
				setTimeout(() => {
					const nextIndex = Math.min(deleteIndex.index, updated.length - 1)
					inputRefs.current[nextIndex]?.focus()
				}, 100)
			}
			else{
				// delete stored unitmix
				if(deleteIndex?.data?.unitId){
					handleConfirmMixDeleteSubmit(deleteIndex?.data?.unitId, localCustomerData?.[0]?.contactInfoId)
				}
			}
			setShowDeleteModal(false)
			setDeleteIndex(null)
		}
	}

	return (
		<Fragment>
			<Modal show={handleLayoutModelOpen} size="md">
				<Form>
					<Modal.Header >
						<Modal.Title>Edit Unit Mix</Modal.Title>
					    <button type="button" className="btn-close" aria-label="Close" onClick={handleLayoutUnitMixClose}></button>
					</Modal.Header>
					<Modal.Body>
						<div className="overflow-auto unit-mix-table-block" style={{ maxHeight: '500px' }}>
							<Table responsive bordered>
								<thead>
									<tr>
										<th className="w-50">Unit Type</th>
										<th className="w-50">
											<div className="d-flex justify-content-between align-items-center">
												<span>Unit Name</span>
												<Button
													variant="outline-success"
													size="sm"
													onClick={handleAddUnit}
												>
													+ Add More
												</Button>
											</div>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										{unitMixData ?
											<td>
												<input
													className="form-control form-control-sm"
													value={unitMixData.unitType ? unitMixData.unitType : null}
													onChange={e => handleUnitMixTypeChange(e, unitMixData.unitType)}
												/>
											</td> : null
										}
										<td className="p-0">
											<div className="unit-number-list small p-2">
												{unitMixData && unitMixData.unitName && unitMixData.unitName.length > 0 &&
													unitMixData.unitName.map((data, index) => {
														const isNew = !data.unitId;
														const isCustomerCreated = data.createdByRole === 'Customer';
														return (
															<div className="position-relative" key={index}>
																<input
																	className={`form-control form-control-sm unit-number-box${isCustomerCreated ? ' customer-created-unit' : ''}`}
																	ref={(el) => (inputRefs.current[index] = el)}
																	name="unit-number-box"
																	value={data.unitName}
																	onChange={(e) => handleUnitNameChange(e.target.value, index)}
																	disabled={!isNew && hasNewUnits} // disable old inputs only if new ones are added
																	title={isCustomerCreated ? 'Added by customer' : undefined}
																	style={isCustomerCreated ? { backgroundColor: '#fff3cd', borderColor: '#ffc107' } : undefined}
																/>
																<Icon
																	title="Delete Unit Name"
																	role="button"
																	className="text-danger remove-unit-name"
																	size={18}
																	icon={xCircle}
																	onClick={() => {
																		setDeleteIndex({
																		  index,
																		  isNewUnit: isNew && hasNewUnits,
																		  data
																		});
																		setShowDeleteModal(true);
																	}}
																/>

															</div>
														);
													})}
											</div>
										</td>
									</tr>
								</tbody>
							</Table>
							{duplicatesUnitData && duplicatesUnitData.length > 0 ?
								<div>
									Duplicate unit name/s, rename to make it unique:
									{duplicatesUnitData.map((data, index) => (
										<div key={index}>
											<span>{data.name ? ' ' + data.name + '(' + data.count + ')' : null}</span>
										</div>
									))}
								</div> : null
							}
						</div>
					</Modal.Body>
					<Modal.Footer className="justify-content-center">
						<Button
							variant="success"
							onClick={handleAddAndSaveNewUnits}
							disabled={!hasNewUnits}
						>
							Save Add
						</Button>
						<Button variant="primary" onClick={handleLayoutUnitMixSave} disabled={hasNewUnits}>Save Edit</Button>
						{/* <Button variant="secondary" onClick={handleLayoutUnitMixClose}>No</Button> */}
					</Modal.Footer>
				</Form>
				<Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
					<Modal.Header closeButton>
						<Modal.Title>Confirm Delete</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						Are you sure you want to delete this unit?
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
							Cancel
						</Button>
						<Button variant="danger" onClick={() => handleConfirmDelete()}>
							Delete
						</Button>
					</Modal.Footer>
				</Modal>
			</Modal>
		</Fragment>
	)
};

export default EditLayoutModal;